import React from 'react';
import cx from 'classnames';
import { WrapTextNodes } from '../../../utils/WrapTextNodes';
import styles from './AccordionGroup.module.scss';
import { AccordionGroupProps } from './AccordionGroup.types';

const AccordionGroup = (props: AccordionGroupProps) => {
  const { name, ...rest } = props;
  return (
    <div className={cx(styles.root, props.className)} {...rest}>
      {React.Children.map(props.children, child => {
        if (typeof child === 'string' || typeof child === 'number') {
          return <WrapTextNodes>{child}</WrapTextNodes>;
        } else {
          return React.isValidElement(child) ? React.cloneElement(child, { ...{ name } }) : child;
        }
      })}
    </div>
  );
};

export default AccordionGroup;
